import { QueryClient,QueryClientProvider } from '@tanstack/react-query'
import { App as AntdApp,ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { ThemeProvider,useTheme } from '@hooks/useTheme'
import App from './App'
import './index.css'

// 配置dayjs中文语言
dayjs.locale('zh-cn')

// 创建React Query客户端
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5分钟
    },
  },
})

/**
 * 应用包装组件
 * 使用主题上下文提供主题配置
 */
const AppWrapper: React.FC = () => {
  const { antdThemeConfig } = useTheme()

  return (
    <ConfigProvider
      locale={zhCN}
      theme={antdThemeConfig}
    >
      <AntdApp>
        <App />
      </AntdApp>
    </ConfigProvider>
  )
}

// 部署在子路径时（如 /mdn/），BrowserRouter 的 basename 需与之对齐
// import.meta.env.BASE_URL 是 Vite 内置变量，等于 vite.config.ts 的 base 值（带尾斜杠）
const routerBasename = import.meta.env.BASE_URL.replace(/\/$/, '')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AppWrapper />
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
)
